import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { serviceRadiusAPI } from '../../services/api';

// Get initial state
const getInitialState = () => {
  return {
    services: [],
    summary: null,
    isLoading: false,
    error: null,
  };
};

// ==================== GET SERVICE RADIUS ====================
export const getServiceRadius = createAsyncThunk(
  'serviceRadius/getServiceRadius',
  async (_, { rejectWithValue }) => {
    try {
      const response = await serviceRadiusAPI.getServicesRadius();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.Error ||
        error.response?.data?.message ||
        'Failed to fetch service radius.'
      );
    }
  }
);

// ==================== UPDATE SERVICE RADIUS ====================
export const updateServiceRadius = createAsyncThunk(
  'serviceRadius/updateServiceRadius',
  async (data, { rejectWithValue }) => {
    try {
      const response = await serviceRadiusAPI.updateServiceRadius(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.Error ||
        error.response?.data?.message ||
        'Failed to update service radius.'
      );
    }
  }
);

// ==================== SERVICE RADIUS SLICE ====================
const serviceRadiusSlice = createSlice({
  name: 'serviceRadius',
  initialState: getInitialState(),
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // GET SERVICE RADIUS
    builder
      .addCase(getServiceRadius.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getServiceRadius.fulfilled, (state, action) => {
        state.isLoading = false;
        state.services = action.payload.Services || [];
        state.summary = action.payload.Summary || null;
        state.error = null;
      })
      .addCase(getServiceRadius.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // UPDATE SERVICE RADIUS
    builder
      .addCase(updateServiceRadius.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateServiceRadius.fulfilled, (state, action) => {
        state.isLoading = false;
        // Update the services list with new data from response
        state.services = action.payload.Services || state.services;
        state.error = null;
      })
      .addCase(updateServiceRadius.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = serviceRadiusSlice.actions;
export default serviceRadiusSlice.reducer;
